export default {
  apiUrl: 'https://api.hirsch-apotheke-korbach.de',
};
